import { Grid } from "@chakra-ui/react";
import GameItem from "./GameItem";
import getMediaUrl from "../../utilities/getMediaUrl";

function AvailableGames({ games, minW = "240px", onItemHover, isPC }) {
  return (
    <Grid
      templateColumns={{
        base: "repeat(2, 1fr)",
        sm: "repeat(3, 1fr)",
        md: "repeat(4, 1fr)",
        lg: "repeat(5, 1fr)",
        xl: "repeat(6, 1fr)",
      }}
      gap={{ base: 4, md: 5, xl: 6 }}
      w="100%"
      maxW="100%"
      m={0}
      px={{ base: 2, md: 4 }}
      py={{ base: 2, md: 4 }}
      alignItems="stretch"
      justifyItems="stretch"
    >
      {games.filter(Boolean).map((game) => {
        const { title, thumbnail, id, ratings, hover_video } = game;
        return (
          <GameItem
            key={id}
            id={id}
            title={title}
            rating={ratings}
            thumbnail={getMediaUrl(thumbnail.url)}
            // vidPath={getMediaUrl(hover_video.url)}
            onHover={onItemHover}
            gameData={game}
            isPC={isPC}
          />
        );
      })}
    </Grid>
  );
}

export default AvailableGames;
